import { type ILeadTag } from '@inpart-io/padme-iap';
import { type MutationTree } from 'vuex';

import { type ILeadTagState } from './types';

export const RECEIVE_TAG_FOR_LEAD = 'receiveTagForLead';
export const ADD_TAG_FOR_LEAD = 'addTagForLead';
export const REMOVE_TAG_FOR_LEAD = 'removeTagForLead';

export const mutations: MutationTree<ILeadTagState> = {
    [RECEIVE_TAG_FOR_LEAD](_state: ILeadTagState, { leadId, tagList }: { leadId: number; tagList: number[] }) {
        _state.tagListByLead.set(leadId, tagList);
    },

    [ADD_TAG_FOR_LEAD](_state: ILeadTagState, { leadIds, tag }: { leadIds: number[]; tag: ILeadTag }) {
        leadIds.forEach((leadId) => {
            if (!_state.tagListByLead.has(leadId)) {
                _state.tagListByLead.set(leadId, []);
            }

            const leadTagList = _state.tagListByLead.get(leadId);
            let done = false;

            for (let i = 0; i < leadTagList.length && !done; ++i) {
                if (_state.dataObjectList.get(leadTagList[i]).label.localeCompare(tag.label) > 0) {
                    leadTagList.splice(i, 0, tag.dobjId);
                    done = true;
                }
            }

            if (!done) {
                leadTagList.push(tag.dobjId);
            }

            _state.tagListByLead.set(leadId, leadTagList);
        });
    },

    [REMOVE_TAG_FOR_LEAD](_state: ILeadTagState, { leadIds, tagId }: { leadIds: number[]; tagId: number }) {
        leadIds?.forEach((leadId) => {
            if (_state.tagListByLead.has(leadId)) {
                const filtered = _state.tagListByLead.get(leadId).filter((tag: number) => {
                    return tag !== tagId;
                });
                _state.tagListByLead.set(leadId, filtered ?? []);
            }
        });
    }
};
